import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProfessionalRoutingModule } from './professional-routing.module';
import { VerticalMenuTypeOneModule } from '../navigation';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { LoaderGlobeAnimationDetailComponent } from '../loaders';
import { ReactiveFormsModule } from '@angular/forms';
import { ProfessionalHomeComponent } from './professional-home/professional-home.component';
import { AvatarPillComponent, ComingSoonModule, PaginationModule, IconPillComponent, ImageUrlPipe, ImageForRolePipe, UserAvatarPipe } from '@frontend/shared';
import { LanguageModule } from '../language';
import { ProfessionalContributionsParentComponent } from './contributions-parent/contributions-parent.component';
import { ScoreHighlightModule } from '../content';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ContributionAnonymityLevelFormModule } from '../contributions';
import { ContributionManagementComponent } from './contribution-management/contribution-management.component';
import { RouterModule } from '@angular/router';
import { ProfessionalBioComponent } from './professional-bio/professional-bio.component';
import { ProfessionalStatusComponent } from './professional-status/professional-status.component';
import { ProfessionalLinksComponent } from './professional-links/professional-links.component';
import { ProfessionalSpecialismsComponent } from './specialisms/professional-specialisms.component';
import { ProfessionalCulturesComponent } from './cultures/professional-cultures.component';


@NgModule({
  declarations: [
    ProfessionalHomeComponent,
    ProfessionalContributionsParentComponent,
    ContributionManagementComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    ProfessionalRoutingModule,
    TranslocoModule,
    VerticalMenuTypeOneModule,
    AlertModule,
    LoaderGlobeAnimationDetailComponent,
    ComingSoonModule,
    LanguageModule,
    IconPillComponent,
    AvatarPillComponent,
    PaginationModule,
    ScoreHighlightModule,
    CollapseModule,
    ContributionAnonymityLevelFormModule,
    ProfessionalBioComponent,
    ProfessionalStatusComponent,
    ProfessionalLinksComponent,
    ProfessionalSpecialismsComponent,
    ProfessionalCulturesComponent,
    ImageUrlPipe,
    ImageForRolePipe,
    UserAvatarPipe,
  ],
  exports: [
    ProfessionalHomeComponent
  ],
  providers: [
    { provide: TRANSLOCO_SCOPE, useValue: 'contributions' },
  ],

})
export class ProfessionalModule { }
